const Icon: React.FunctionComponent<React.SVGAttributes<SVGElement>> = (
  props
) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.3668 1.75604H12.914V15.7115C12.914 17.3743 11.586 18.7401 9.9334 18.7401C8.28077 18.7401 6.95278 17.3743 6.95278 15.7115C6.95278 14.0784 8.25127 12.7422 9.84488 12.6829V9.17917C6.33305 9.23853 3.5 12.1187 3.5 15.7115C3.5 19.334 6.39207 22.2438 9.96292 22.2438C13.5337 22.2438 16.4258 19.3043 16.4258 15.7115V8.5556C17.7243 9.50578 19.3179 10.0699 21 10.0996V6.59592C18.4031 6.50684 16.3668 4.36898 16.3668 1.75604Z"
      fill="white"
    />
  </svg>
);

export default Icon;
